import produce from 'immer'
import { SET_PAYMENTS } from './actionTypes'

export const initialState = {
  payments: {
    data: [],
    count: null,
  },
}

const paymentReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_PAYMENTS:
        draft.payments = action.data
        break
    }
  })

export default paymentReducer
